import { render, staticRenderFns } from "./BetslipBetComboB.vue?vue&type=template&id=f3844212&scoped=true"
import script from "./BetslipBetComboB.vue?vue&type=script&lang=js"
export * from "./BetslipBetComboB.vue?vue&type=script&lang=js"
import style0 from "./BetslipBetComboB.vue?vue&type=style&index=0&id=f3844212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3844212",
  null
  
)

export default component.exports